var map = {
	"./guanyuwomen.png": "7f2f",
	"./home_phone.png": "dc63",
	"./home_wechat.png": "feb2",
	"./jiejuefangan01.png": "4504",
	"./jiejuefangan02.png": "8cf6",
	"./jiejuefangan03.png": "a749",
	"./jingxuan01.png": "fc57",
	"./jingxuan02.png": "a4fa",
	"./jingxuan03.png": "f8907",
	"./logo1.png": "5d3e",
	"./logo2.png": "17ce",
	"./qrcode.png": "4091",
	"./yingxiao01.png": "8a55",
	"./yingxiao02.png": "a2d4",
	"./yingxiao03.png": "343b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9028";